import { RootPage } from "../page";
import $api from "../../api";

class SignUpView extends RootPage {
  constructor() {
    super();

    this.invitationCode = ko.observable();
    this.isFromInvitation = ko.computed(() => {
      //console.log('ISFROMINV', !(this.invitationCode() === '' || this.invitationCode() === null || this.invitationCode() === undefined));
      return !(
        this.invitationCode() === "" ||
        this.invitationCode() === null ||
        this.invitationCode() === undefined
      );
    });

    this.email = ko.observable().extend({ email: true }); // email is also required at the same time
    this.companyName = ko.observable().extend({
      required: () => {
        return !this.isFromInvitation();
      },
    });
    this.password = ko.observable().extend({ required: true });
    this.passwordAgain = ko.observable(); //.extend({ mustMatch: this.password });
    this.firstname = ko.observable().extend({ required: true });
    this.lastname = ko.observable().extend({ required: true });
    this.phone = ko.observable();
    this.termsAgreed = ko.observable();
    this.userSource = ko.observable(parseUrlParams());

    this.fullName = ko.computed({
      read: () => {
        return `${this.firstname()} ${this.lastname()}`;
      },
      write: (val) => {
        var parsed = val.split(" ").filter((v) => !!v);
      },
    });
  }

  linkedin() {
    let path = "/account/sign-provider?provider=LinkedIn";

    if (this.invitationCode()) {
      path += "&invCode=" + encodeURIComponent(this.invitationCode);
    }

    window.location.href = path;
  }

  submitSignUp() {
    this.startSubmitting();

    $api.account.signUp(
      {},
      {
        email: this.email(),
        companyName: this.companyName(),
        invitationCode: this.invitationCode(),
        password: this.password(),
        firstname: this.firstname(),
        lastname: this.lastname(),
        phone: this.phone(),
        sourceData: this.userSource(),
      },
      (resp) => {
        this.stopSubmitting();

        TRACK_DELAYED_EVENT(
          "Users",
          "Sign Up",
          this.invitationCode() ? "Invitation" : "Direct"
        );

        if (!this.invitationCode()) {
          TRACK_CONVERSION("conversion_signup");

          TRACK_DELAYED_EVENT("Conversion", "CompleteRegistration", {
            isMobile: window.isMobileBrowser(),
          });
        }

        window.location.href = "/";
      }
    );
  }
}

export default SignUpView;

function getParam(p) {
  var match = RegExp("[?&]" + p + "=([^&]*)").exec(window.location.search);
  return match && decodeURIComponent(match[1].replace(/\+/g, " "));
}

function getExpiryRecord(value) {
  var expiryPeriod = 90 * 24 * 60 * 60 * 1000; // 90 day expiry in milliseconds

  var expiryDate = new Date().getTime() + expiryPeriod;
  return {
    value: value,
    expiryDate: expiryDate,
  };
}

function parseUrlParams() {
  var gclidParam = getParam("gclid");
  var gclidRecord = null;

  var gclsrcParam = getParam("gclsrc");
  var isGclsrcValid = !gclsrcParam || gclsrcParam.indexOf("aw") !== -1;

  if (gclidParam && isGclsrcValid) {
    gclidRecord = getExpiryRecord(gclidParam);
    localStorage.setItem("gclid", JSON.stringify(gclidRecord));
  }

  var gclid = gclidRecord || JSON.parse(localStorage.getItem("gclid"));
  var isGclidValid = gclid && new Date().getTime() < gclid.expiryDate;

  var res = {};

  if (isGclidValid) {
    //currGclidFormField.value = gclid.value;
    // TODO: save
    res.glCId = gclid.value;
  }

  res.utmMedium = getParam("utm_medium");
  res.utmTerm = getParam("utm_term");
  res.utmSource = getParam("utm_source");
  res.utmCampaign = getParam("utm_campaign");
  res.utmContent = getParam("utm_content");

  return res;
}
